import React, { useEffect, useState } from "react";
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import logo from '../pages/AIMS-QR.jpg';

export function Login({ embedded = false }) {
  
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState ("");
    
    const [loginStatus, setLoginStatus] = useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    const [serverErrorLogin, setServerErrorLogin] = useState(true);
    const [invalidCredsLogin, setInvalidCredsLogin] = useState(true);
    const [emptyCredsLogin, setEmptyCredsLogin] = useState(true);
    const [serverErrorLoginKey, setServerErrorLoginKey] = useState();
    
    var passwordFailMessage;

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
    event.preventDefault();}

    useEffect(()=> {
      if (!localStorage.getItem('token')) {
        setLoginStatus(false);
      } else {
        setLoginStatus(true);
      }
    },[]);
  
    const login = () => {
      if(password === '' || username === '') {
        setEmptyCredsLogin(false);
        setInvalidCredsLogin(true);
        setServerErrorLogin(true);
        // setServerErrorLoginKey(`${Math.floor((Math.random() * 1000))}-min`);
      } else {
        console.log('login');
    const url = baseUrl+"user/login";
    var payload = {
      "userName": username,
      "password": password,
    }
    fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',            
        },
        body: ( "json", JSON.stringify( payload ) )
      })
        .then((response) => response.json())
      .then((data) => {
        console.log(data)
        if (data === {}) {
          setLoginStatus(false);
          setEmptyCredsLogin(true);
          setInvalidCredsLogin(false);
          setServerErrorLogin(true);
          // setServerErrorLoginKey(`${Math.floor((Math.random() * 1000))}-min`);
        } else {
          console.log("login: ",data);
          localStorage.setItem("token", data.token)
          localStorage.setItem("username", data.result.userName)
          localStorage.setItem("bToken", data.bToken)
          localStorage.setItem("name", data.result.name)
          localStorage.setItem("canSearch", data.result.canSearch)
          localStorage.setItem("canDeleteAsset", data.result.canDeleteAsset)
          localStorage.setItem("canAddAsset", data.result.canAddAsset)
          localStorage.setItem("canEditAsset", data.result.canEditAsset)
          localStorage.setItem("canInspectAsset", data.result.canInspectAsset)
          localStorage.setItem("canAddAttachment", data.result.canAddAttachment)
          localStorage.setItem("canRegisterUser", data.result.canRegisterUser)
          localStorage.setItem("canUpdateUser", data.result.canUpdateUser)
          localStorage.setItem("canBulkAdd", data.result.canBulkAdd)
          localStorage.setItem("canAddDefect", data.canAddDefect)
          localStorage.setItem("canViewPlatformDashboard", data.result.canViewPlatformDashboard)
          localStorage.setItem("canAdminReport", data.result.canAdminReport)
          setLoginStatus (true);
          window.location.reload();
        }
      }).catch((error) => {
        setLoginStatus(false);
        setEmptyCredsLogin(true);
        setInvalidCredsLogin(true);
        setServerErrorLogin(false);
        // setServerErrorLoginKey(`${Math.floor((Math.random() * 1000))}-min`);
     });;
    }
    };
  
    return (
      <Box sx={embedded
        ? { width: '100%' }
        : { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)', p: 2 }}>
        <Box sx={{ width: '100%', maxWidth: 380, mx: 'auto' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2.5 }}>
            <Box component="img" src={logo} alt="A1MS-QR — Asset Inspection Management Solutions" sx={{ width: 150, height: 150, borderRadius: 'var(--r)', boxShadow: 'var(--shadow)' }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'var(--text)', mt: 1.5 }}>Welcome Back</Typography>
            <Typography variant="body2" sx={{ color: 'var(--muted)' }}>Sign in to continue</Typography>
          </Box>
          <Box sx={{ background: 'var(--surface)', borderRadius: 'var(--r)', border: '1px solid var(--border)', boxShadow: 'var(--shadow)', p: 3 }}>
          <TextField
            fullWidth
            label="Username"
            variant="outlined"
            margin="dense"
            type="text"
            onChange={(e) => { setUsername(e.target.value); }}
            onKeyDown={(e) => (e.keyCode === 13 ? login(e) : null)}
          />
          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            margin="dense"
            type={showPassword ? 'text' : 'password'}
            onChange={(e) => { setPassword(e.target.value); }}
            onKeyDown={(e) => (e.keyCode === 13 ? login(e) : null)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <div key={serverErrorLoginKey} hidden={emptyCredsLogin}><p className="warningText">Please enter a Username and Password to Login.</p></div>
          <div key={serverErrorLoginKey} hidden={invalidCredsLogin}><p className="warningText">Invalid Username/Password Combination Entered!</p></div>
          <div key={serverErrorLoginKey} hidden={serverErrorLogin}><p className="warningText">Server Error, Please try again later.</p></div>
          <Button variant="contained" fullWidth onClick={login} sx={{ mt: 1.5, py: 1.2, fontWeight: 600 }}>Login</Button>
          <Box sx={{ mt: 2, textAlign: 'center', fontSize: 12, color: 'var(--muted)', lineHeight: 1.5 }}>
            Please contact your 1 Maintenance rep if you require a login to AIMS.
          </Box>
          </Box>
        </Box>
        {!embedded && (
          <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, py: 1.5, textAlign: 'center', fontWeight: 600, fontSize: 13, letterSpacing: '.02em', color: 'var(--muted)', background: 'var(--surface)', borderTop: '1px solid var(--border)' }}>
            1 Maintenance &amp; Supply
          </Box>
        )}
      </Box>
    );
  }

export default Login